import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfig } from './config';

export const msalInstance = new PublicClientApplication(getMsalConfig());
